import { BaseOptionModel } from '../../model';
import { FabricationMethod } from '../../model/fabrication-method';

export const FabricationMethodOptions: BaseOptionModel<FabricationMethod>[] = [
    { label: '打印服务', value: FabricationMethod.printAndShip },
    { label: '仅设计', value: FabricationMethod.selfPrint },
];
